export default {
  date: 'May 2, 2024',
  title: "The Getfloorplan layouts are more realistic now. We've added sunlight",
  description: 'With "Sunlight," your home for sale will become even cozier and more comfortable',
  id: 'sunlight',
  jsx: () => (
    <div class='novelty__text'>
      <p>We have some exciting news for you! Getfloorplan layouts have become even more realistic. We've added sunlight to them.</p>
      <p>Now users can enjoy even more realistic virtual tours and 3D floor plans.</p>
      <p>With "Sunlight," your home for sale will become even cozier and more comfortable. Imagine: sunlight streaming through the windows, creating an atmosphere of warmth and coziness in every room.</p>
      <p>Now your clients can truly feel at home, even in virtual space. They can see how their home will look on a sunny day, helping them make more informed decisions when planning their future housing. Experience realism with Getfloorplan and create your ideal home today!</p>
    </div>
  ),
  thumb: 'news/15.webp',
};
